import {Component} from '@angular/core';
import {LoanApplicationService} from '../loan-application.service';
import {LoanApplication} from '../../../@models/loan-application.model';

@Component({
  selector: 'bb-employment-type',
  templateUrl: './employment-type.component.html',
  styleUrls: ['./employment-type.component.scss'],
})
export class EmploymentTypeComponent {
  EmploymentType = LoanApplication.EmploymentType;
  control = this.loan.form.get('employment_info.employment_type');
  valueChanges = this.control.valueChanges.startWith(this.control.value);
  isLandbased = this.valueChanges.map(e => e === LoanApplication.EmploymentType.land);
  isSeaman = this.valueChanges.map(e => e === LoanApplication.EmploymentType.sea);

  constructor(private loan: LoanApplicationService) {
  }
}
